<template>
  <div>
    <div class="flex flex-col w-full bg-white rounded p-4">
      <div class="flex flex-col w-1/2 mb-6">
        <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_name') }}</label>
        <text-input
          v-model="localModel.name"
          :validator="$v.localModel.name"
          :attribute="$t('frontend_groovesell_coupons_step1_coupon_name')"
          value="localModel.name"
          :placeholder="$t('frontend_groovesell_coupons_step1_coupon_name')"
        />
      </div>
      <div class="flex flex-col w-1/2 mb-6">
        <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_desc') }}</label>
        <text-area
          v-model="localModel.description"
          :validator="$v.localModel.description"
          :attribute="$t('frontend_groovesell_coupons_step1_coupon_desc')"
          value="localModel.description"
          :placeholder="$t('frontend_groovesell_coupons_step1_coupon_desc')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'Step1',
  props: {
    model: {
      required: true
    }
  },
  data() {
    return {
      localModel: this.model,
    };
  },
  validations: {
    localModel: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(80)
      },
      description: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(160)
      }
    }
  },
  computed: {},
  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    }
  },
  created() {},
  methods: {
    validate() {
      this.$v.$touch();
      var isValid = !this.$v.$invalid;
      this.$emit('on-validate', isValid);
      return isValid;
    }
  }
};
</script>
